import React, {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react'

export type DynamicHeaderState = {
  headerTitle?: string | ReactNode | null
  showGoBack?: boolean
  goBackUrl?: string | null
  actionButton?: ReactNode | null
}

type DynamicHeaderTypes = DynamicHeaderState & {
  setHeaderContent: Dispatch<SetStateAction<DynamicHeaderState>>
}

const DynamicHeaderContext = createContext<DynamicHeaderTypes>({
  headerTitle: null,
  showGoBack: false,
  goBackUrl: null,
  actionButton: null,
  setHeaderContent: () => {},
})

export const DynamicHeaderProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [headerContent, setHeaderContent] = useState<DynamicHeaderState>({
    headerTitle: null,
    showGoBack: false,
    goBackUrl: null,
    actionButton: null,
  })

  return (
    <DynamicHeaderContext.Provider
      value={{ ...headerContent, setHeaderContent }}
    >
      {children}
    </DynamicHeaderContext.Provider>
  )
}

export const useDynamicHeader = () => useContext(DynamicHeaderContext)
